import { render, staticRenderFns } from "./DisplayRouteOfAdministrationStatuses.vue?vue&type=template&id=2f99e426&scoped=true&"
import script from "./DisplayRouteOfAdministrationStatuses.vue?vue&type=script&lang=js&"
export * from "./DisplayRouteOfAdministrationStatuses.vue?vue&type=script&lang=js&"
import style0 from "./DisplayRouteOfAdministrationStatuses.vue?vue&type=style&index=0&id=2f99e426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99e426",
  null
  
)

export default component.exports